// Maps a URL pathname to the canonical Amplitude `page_type` value, following
// the URL patterns in the Amplitude data dictionary's Page Type table. Used by
// the page-type enrichment plugin so every event carries `page_type` without
// each surface threading a prop. Returns undefined for unrecognized paths so
// the plugin omits the property rather than stamping a wrong value.

const LOCALE_SEGMENT = /^[a-z]{2}-[a-z]{2}$/;

const C2C_MODE_SEGMENTS = new Set(['bus', 'train', 'travel', 'ferry', 'flight']);

export function resolvePageType(pathname: string | undefined): string | undefined {
    if (!pathname) {
        return undefined;
    }

    const segments = pathname.split('/').filter(Boolean);

    // Blog pages are not locale-prefixed: `/blog/*`.
    if (segments[0] === 'blog') {
        return 'blog';
    }

    // Drop an optional leading locale segment (e.g. `en-us`, `es-mx`).
    const rest = segments[0] && LOCALE_SEGMENT.test(segments[0])
        ? segments.slice(1)
        : segments;

    if (rest.length === 0) {
        return 'homepage';
    }

    if (C2C_MODE_SEGMENTS.has(rest[0])) {
        return 'landing_c2c';
    }

    switch (rest[0]) {
        case 'depart':
        case 'return':
            return 'search_results';
        case 'carrier':
            return 'landing_carrier';
        case 'explore':
            return 'explore';
        case 'tripsummary':
            return 'trip_summary';
        case 'checkout':
            return 'checkout';
        case 'account':
            return 'account';
        default:
            return undefined;
    }
}
